
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {WorkerRechargeCard} from "../models/workerRechargeCard";
import {map} from "rxjs/operators";



@Injectable({ providedIn: 'root' })
export class WorkerRechargeCardService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    findByUser(userId: string) {
        return this.http.get<WorkerRechargeCard>(`${environment.apiEndpoint}/v1/worker-recharge-cards/by-user/` + userId, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/worker-recharge-cards/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

}
